// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_terms_page_root__SWQky"};